
export class MaintenanceOrderImportModel {
    counter: number = 0;
    companyId: number = 0;
    branchId: number = 0;
    maintenanceOrderClass: number = 0;
    maintenanceOrderType: number = 0;
    maintenanceOrderConsecutive: number = 0;
    maintenanceOrderAlterNumber: number | null = null
    maintenanceOrderDate: Date = new Date();
    workshopType: number = 0;
    clientDocument: string | null = null;
    clientDocument2: string | null = null;
    costCenterCode: number | null = null;
    equipmentCode: number = 0;
    storeCode: number = 0;
    mechanicDocument: string = "";
    maintenanceType: number = 0;
    initialDate: Date = new Date();
    initialDiagnosis: string | null = null;
    finalDate: Date | null = null;
    finalDiagnosis: string | null = null;
    repairHours: number = 0;
    kmHoromValue: number = 0;
    stageCode: number = 0;
    reportedBy: string | null = null;
    receivedBy: string | null = null;
    contactConstructionSite: string | null = null;
    dateCompromise: Date | null = null;
    transportDocument: string | null = null;
    vehicleCode: number | null = null;
    transportValue: number = 0;
    transportValueToPay: number = 0;
    valueToInvoiced: number = 0;
    invoiceNumber: string | null = null;
    swChargeConstructionSite: string = "N";
    costRepairValue: number = 0;
    swDeliveredOnTime: string | null = null;
    qualification: number | null = null;
    stateMaintenanceOrder: number = 1;

    constructor(counter: number,
        companyId: number,
        branchId: number,
        maintenanceOrderClass: number,
        maintenanceOrderType: number,
        maintenanceOrderConsecutive: number,
        maintenanceOrderAlterNumber: number | null,
        maintenanceOrderDate: Date,
        workshopType: number,
        clientDocument: string | null,
        clientDocument2: string | null,
        costCenterCode: number | null,
        equipmentCode: number,
        storeCode: number,
        mechanicDocument: string,
        maintenanceType: number,
        initialDate: Date,
        initialDiagnosis: string | null,
        finalDate: Date | null,
        finalDiagnosis: string | null,
        repairHours: number,
        kmHoromValue: number,
        stageCode: number,
        reportedBy: string | null,
        receivedBy: string | null,
        contactConstructionSite: string | null,
        dateCompromise: Date | null,
        transportDocument: string | null,
        vehicleCode: number | null,
        transportValue: number,
        transportValueToPay: number,
        valueToInvoiced: number,
        invoiceNumber: string | null,
        swChargeConstructionSite: string,
        costRepairValue: number,
        swDeliveredOnTime: string | null,
        qualification: number | null,
        stateMaintenanceOrder: number,
    ) {
        this.counter = counter
        this.companyId = companyId;
        this.branchId = branchId;
        this.maintenanceOrderClass = maintenanceOrderClass;
        this.maintenanceOrderType = maintenanceOrderType;
        this.maintenanceOrderConsecutive = maintenanceOrderConsecutive;
        this.maintenanceOrderAlterNumber = maintenanceOrderAlterNumber;
        this.maintenanceOrderDate = maintenanceOrderDate;
        this.workshopType = workshopType;
        this.clientDocument = clientDocument;
        this.clientDocument2 = clientDocument2;
        this.costCenterCode = costCenterCode;
        this.equipmentCode = equipmentCode;
        this.storeCode = storeCode;
        this.mechanicDocument = mechanicDocument;
        this.maintenanceType = maintenanceType;
        this.initialDate = initialDate;
        this.initialDiagnosis = initialDiagnosis;
        this.finalDate = finalDate;
        this.finalDiagnosis = finalDiagnosis;
        this.repairHours = repairHours;
        this.kmHoromValue = kmHoromValue;
        this.stageCode = stageCode;
        this.reportedBy = reportedBy;
        this.receivedBy = receivedBy;
        this.contactConstructionSite = contactConstructionSite;
        this.dateCompromise = dateCompromise;
        this.transportDocument = transportDocument;
        this.vehicleCode = vehicleCode;
        this.transportValue = transportValue;
        this.transportValueToPay = transportValueToPay;
        this.valueToInvoiced = valueToInvoiced;
        this.invoiceNumber = invoiceNumber;
        this.swChargeConstructionSite = swChargeConstructionSite;
        this.costRepairValue = costRepairValue;
        this.swDeliveredOnTime = swDeliveredOnTime;
        this.qualification = qualification;
        this.stateMaintenanceOrder = stateMaintenanceOrder;
    }
}
